export default {
      id: "command__history-order-usage",
      viewBox: "0 0 44.33 40.38",
      url: __webpack_public_path__ + "img/icons.svg#command__history-order",
      toString: function () {
        return this.url;
      }
    }